<template>
  <vx-card>
    <div class="flex justify-end">
      <vs-button v-if="isEdit" color="primary" type="filled" @click.prevent="nextForm()" class="mr-4">Update Camera</vs-button>
      <vs-button @click="$router.push({name:'org_management_sites'})" color="danger" type="filled" icon-pack="feather" icon="icon-x" class="mr-4">Cancel</vs-button>
      <vs-button v-if="isEdit" color="primary" type="filled" icon-pack="feather" icon="icon-save" @click.prevent="updateSite()">Save</vs-button>
      <vs-button v-else color="primary" type="filled" icon-pack="feather" @click.prevent="nextForm()"><span>Next</span> <vs-icon icon="chevron_right" /></vs-button>
    </div>

    <div class="vx-row pt-8">
      <div class="vx-col w-full">
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/4 w-full">
            <span>Site Name</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <vs-input disabled class="w-full" v-model="name" />
            <span class="text-danger text-sm" v-show="error.name != ''">{{error.name}}</span>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/4 w-full">
            <span>URL</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <div class="w-full input-url">
              <div class="pre-ph">https://</div>
              <input type="text" v-model="ipAddress" placeholder="www.your-site.com:8081" @blur="getSiteInfo" />
            </div>
            <span class="text-danger text-sm" v-show="error.ipAddress != ''">{{error.ipAddress}}</span>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/4 w-full">
            <span>Username</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <vs-input class="w-full" v-model="username" @blur="getSiteInfo" />
            <span class="text-danger text-sm" v-show="error.username != ''">{{error.username}}</span>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/4 w-full">
            <span>Password</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <vs-input type="password" class="w-full" v-model="password" @blur="getSiteInfo" />
            <span class="text-danger text-sm" v-show="error.password != ''">{{error.password}}</span>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/4 w-full">
            <span>Connected</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <vs-switch v-model="connected" />
          </div>
        </div>
      </div>
    </div>
  </vx-card>
</template>

<script>
  import api from "@/api";
  export default {
    data() {
      return {
        isEdit: false,
        id: "",
        name: "",
        ipAddress: "",
        username: "",
        password: "",
        connected: false,
        error: {
          name: "",
          ipAddress: "",
          username: "",
          password: "",
        }
      };
    },
    computed: {
      site() {
        return this.$store.state.currentSite
      },
      currentSiteForm() {
          return this.$store.state.currentSiteForm
      },
      urlAddress() {
        return `https://${this.ipAddress}`
      }
    },
    mounted() {
      if(this.currentSiteForm != null) {
          this.name = this.currentSiteForm.name
          this.ipAddress = this.currentSiteForm.ipAddress.replaceAll('https://','')
          this.username = this.currentSiteForm.username
          this.password = this.currentSiteForm.password
          this.connected = this.currentSiteForm.onOff == 1 ? true : false

          if(this.currentSiteForm.id != undefined && this.currentSiteForm.id != 0) {
            this.isEdit = true
            this.id = this.currentSiteForm.id
          }
      } else {
        if(this.$route.params.id) {
          this.isEdit = true
          console.log(this.site)
          this.name = this.site.name
          this.ipAddress = this.site.ipAddress.replaceAll('https://','')
          this.username = this.site.username
          this.password = this.site.password
          this.connected = this.site.onOff == 1 ? true : false
        }
      }
    },  
    methods: {
      getSiteInfo() {
        if(this.ipAddress != '' && this.username != '' && this.password != '') {
          api.siteInfo({
            'ipAddress': this.urlAddress,
            'username': this.username,
            'password': this.password,
          })
          .then((result) => result.data)
          .then((data) => {
              console.log(data)
              if(data.status) {
                this.name = data.data[0].name;
                this.id = data.data[0].id;
                this.connected = data.data[0].reachable;
              }
          })
          .catch((e) => {
              console.log(e)
              this.$vs.loading.close()
          });
        }
      },
      nextForm() {
        this.error = {
          name: "",
          ipAddress: "",
          username: "",
          password: "",
        };
        if(!this.validateInput()) {
          return;
        }

        let params = {
          "name": this.name,
          "ipAddress": this.urlAddress,
          "username": this.username,
          "password": this.password,
          "statusId": 1,
          "onOff": this.connected ? 1 : 0
        }

        if(this.isEdit) {
          params['id'] = this.$route.params.id
        }

        this.$store.dispatch('saveSiteForm', params)

        this.$router.push('/org_management/site_cameralists')
      },
      validateInput() {
        let error = 0;
        if(this.name == "") {
          this.error.name = "Please input site name"
          error++
        }
        if(this.ipAddress == "") {
          this.error.ipAddress = "Please input site url"
          error++
        } else {
          if(!this.isValidURL(this.urlAddress)) {
            this.error.ipAddress = "Please input valid site url"
            error++
          }
        }
        if(this.username == "") {
          this.error.username = "Please input username"
          error++
        }
        if(this.password == "") {
          this.error.password = "Please input password"
          error++
        }
        return error == 0
      },
      isValidURL(urlString) {
        var urlPattern = new RegExp('^(https?:\\/\\/)?'+ // validate protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // validate domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))'+ // validate OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // validate port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?'+ // validate query string
        '(\\#[-a-z\\d_]*)?$','i'); // validate fragment locator
        return !!urlPattern.test(urlString);
      },
      updateSite() {
        this.error = {
          name: "",
          ipAddress: "",
          username: "",
          password: "",
        };
        if(!this.validateInput()) {
          return;
        }

        this.$vs.loading()
        api.saveSite({
            "id": this.$route.params.id,
            "name": this.name,
            "ipAddress": this.urlAddress,
            "username": this.username,
            "password": this.password,
            "statusId": 1,
            "onOff": this.connected ? 1 : 0
          }, true)
        .then((result) => result.data)
        .then((data) => {
            this.$vs.loading.close()
            if(!data.status) {
              this.error.name = data.message
            } else {
              this.$vs.notify({
                  title:'Success',
                  text:'Success save data',
                  color:'success',
                  position:'bottom-center'
              })
            setTimeout(() => {
                this.$router.push({name:'org_management_sites'})
            },500)
          }
        })
        .catch((e) => {
            console.log(e)

            this.$vs.notify({
              title:'Failed',
              text:'Save data failed',
              color:'danger',
              position:'bottom-center'
          })

            this.$vs.loading.close()
        });
      },
    }
  };
  </script>

  <style scoped>
    .input-url {
      display: flex;
      align-items: center;
      border: 1px solid rgba(0, 0, 0, 0.2);
      border-radius: 5px;
    }
    .input-url .pre-ph {
      padding-left: 10px;
    }
    .input-url input {
      padding: 10px 2px;
      border: none;
      width: 100%;
    }
  </style>